const MITRA_BANTUAN_TICKET = `/mitra-bantuan/tickets`;
const MITRA_BANTUAN_CHATBOT = '/mitra-bantuan/chatbots';
const MITRA_BANTUAN_CHATBOT_TRANSACTION = '/mitra-bantuan/chatbots/transactions';

// https://blueprint.bukalapak.io/t/mitra~bantuan~mitra~bantuan~tickets~get~mitra-bantuan~tickets
export const retrieveTickets = ($axios, params = {}) => {
  return $axios.$get(MITRA_BANTUAN_TICKET, { params });
};

// https://blueprint.bukalapak.io/t/mitra~bantuan~mitra~bantuan~tickets~get~mitra-bantuan~tickets~id
export const retrieveTicketDetail = ($axios, { id }) => {
  return $axios.$get(`${MITRA_BANTUAN_TICKET}/${id}`);
};

// https://blueprint.bukalapak.io/t/mitra~bantuan~mitra~bantuan~tickets~get~mitra-bantuan~tickets~id~comments
export const retrieveTicketComments = ($axios, { id }) => {
  return $axios.$get(`${MITRA_BANTUAN_TICKET}/${id}/comments`);
};

// https://blueprint.bukalapak.io/t/mitra~bantuan~mitra~bantuan~tickets~put~mitra-bantuan~tickets~id
export const updateTicket = ($axios, { id, requestPayload }) => {
  return $axios.$put(`${MITRA_BANTUAN_TICKET}/${id}`, requestPayload);
};

// https://blueprint.bukalapak.io/t/mitra~bantuan~mitra~bantuan~tickets~post~mitra-bantuan~tickets~attachments
export const uploadTicketAttachment = ($axios, { fileName, fileBase64 }) => {
  return $axios.$post(`${MITRA_BANTUAN_TICKET}/attachments`, { file_name: fileName, file_base64: fileBase64 });
};

// https://blueprint.bukalapak.io/t/mitra~bantuan~mitra~bantuan~chatbots~post~mitra-bantuan~chatbots~initiate
export const initiateChatbot = ($axios, payload) => {
  return $axios.$post(`${MITRA_BANTUAN_CHATBOT}/initiate`, payload);
};

// https://blueprint.bukalapak.io/t/mitra~bantuan~mitra~bantuan~chatbots~transaction~post~mitra-bantuan~chatbots~transactions~id~unstuck
export const chatbotUnstuckTransaction = ($axios, { id, requestPayload }) => {
  return $axios.$post(`${MITRA_BANTUAN_CHATBOT_TRANSACTION}/${id}/unstuck`, requestPayload);
};

// https://blueprint.bukalapak.io/t/mitra~bantuan~mitra~bantuan~chatbots~transaction~post~mitra-bantuan~chatbots~transactions~id~refund
export const chatbotRefundTransaction = ($axios, { id, requestPayload }) => {
  return $axios.$post(`${MITRA_BANTUAN_CHATBOT_TRANSACTION}/${id}/refund`, requestPayload);
};

// https://blueprint.bukalapak.io/t/mitra~bantuan~mitra~bantuan~chatbots~get~mitra-bantuan~chatbots~sessions
export const retrieveChatbotsSession = $axios => {
  return $axios.$get(`${MITRA_BANTUAN_CHATBOT}/sessions`);
};

// https://blueprint.bukalapak.io/t/mitra~bantuan~mitra~bantuan~chatbots~post~mitra-bantuan~chatbots~sessions~close
export const chatbotsCloseConversationSession = $axios => {
  return $axios.$post(`${MITRA_BANTUAN_CHATBOT}/sessions/close`);
};
